<div class="badge-container">
  <rt-icon *ngIf="iconName" size="small-xx" [name]="iconName"></rt-icon>
  <span>{{ text }}</span>
</div>
